
import React, { useState } from 'react';
import { Form as FinalForm, Field } from 'react-final-form';
import {
    Input, Button, Form, Dropdown, Grid
} from 'semantic-ui-react';
import { TextField } from '+/components';
import { useCreateGR, useAvailableGRGroupings, clearGetPricing2Cache } from '~/groupings';
import dayjs from 'dayjs';

const styles = {
    root: {
        padding: '15px'
    }
};

const SpecialsForm = props => {

    const { initialValues } = props;

    const [dropdownOptions, setDropdownOptions] = useState([]);
    const { mutate: createGrouping } = useCreateGR();
    useAvailableGRGroupings(initialValues.property_id, {
        onSuccess: data => {

            const options = createDropdownOptions(
                data.concat(initialValues?.unitTypes || [])
            );

            setDropdownOptions(options);
        }
    });


    const ClearGetPricing2Cache = async property_id => await clearGetPricing2Cache(property_id);


    const onSubmit = async ({ special_type, ...payload }) => {

        payload.unitTypes = payload.unitTypes.map((i => ({ id: i })));
        payload.last_update = dayjs();
        payload.growth_rate = payload.growth_rate / 100;
        createGrouping(payload);

        await ClearGetPricing2Cache(payload.property_id);

        props.closeModal();

    };

    return (

        <FinalForm

            initialValues={{
                ...initialValues,
                growth_rate: (initialValues.growth_rate * 100).toFixed(2),
                date: dayjs(initialValues.date).add(1, 'day').format('YYYY-MM-DD'),
                unitTypes: initialValues.unitTypes?.map(i => i.id) || []
            }}
            validate={validate}
            onSubmit={onSubmit}
            render={({
                handleSubmit, submitting, pristine, hasValidationErrors, errors
            }) => (
                <div style={styles.root}>
                    <Form onSubmit={handleSubmit}>
                        <Grid verticalAlign='bottom' padded='vertically'>
                            <Grid.Row>
                                <Grid.Column width='8'>
                                    <TextField name='name' label='Growth Rate Name' required />
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <Field name='date'>
                                        {({ input, meta }) => (
                                            <Form.Field>
                                                <TextField name='date' label='Last Market Date Change' type='date' required/>
                                            </Form.Field>
                                        )}
                                    </Field>
                                </Grid.Column>
                                <Grid.Column width='4'>
                                    <Field name='growth_rate'>
                                        {({ input, meta }) => (
                                            <Form.Field>
                                                <label htmlFor='growth_rate'> Growth rate </label>
                                                <Input
                                                    style={styles.input}
                                                    step='.01'
                                                    type='number'
                                                    min={0}
                                                    max={100}
                                                    placeholder='Growth Rate' {...input}
                                                    labelPosition='right'
                                                    label={{ content: '%' }}
                                                    required
                                                />
                                            </Form.Field>
                                        )}
                                    </Field>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>

                        <Field name='unitTypes'>
                            {({ input, meta }) => (
                                <Form.Field>
                                    <label htmlFor='unitTypes'> Unit Types</label>
                                    <Dropdown
                                        placeholder='Unit Types'
                                        search
                                        noResultsMessage='No Available Unit Types'
                                        fluid
                                        multiple
                                        selection
                                        options={dropdownOptions}
                                        value={input.value}
                                        onChange={(e, { value }) => input.onChange(value)}
                                    />
                                </Form.Field>
                            )}
                        </Field>

                        <Form.Field>
                            <Button negative onClick={props.closeModal}>
                            Cancel
                            </Button>
                            <Button floated='right' type='submit' disabled={submitting || pristine}>
                            Submit
                            </Button>
                        </Form.Field>
                    </Form>
                </div>
            )}
        />
    );
};

const createDropdownOptions = arr => arr.map(item => ({
    text: item.name,
    value: item.id

}));

const validate = values => {
    const errors = {};

    if (!values.name) {
        errors.name = 'Required.';
    }

    if (!values.growth_rate) {
        errors.growth_rate = 'Required.';
    }

    if (!values.date) {
        errors.date = 'Required.';
    }

    return errors;
};

export default SpecialsForm;
